import { render, staticRenderFns } from "./ChoiceEditor.vue?vue&type=template&id=39d836df&scoped=true"
import script from "./ChoiceEditor.vue?vue&type=script&lang=js"
export * from "./ChoiceEditor.vue?vue&type=script&lang=js"
import style0 from "./ChoiceEditor.vue?vue&type=style&index=0&id=39d836df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d836df",
  null
  
)

export default component.exports